package com.evoapps.evoshift.domain.model

/**
 * A data export the server built (SH-27, functions/dataExport.js): a ZIP with data.json, CSV
 * tables, summary.html and about.txt, downloadable from [url] until [expiresAt] (24 hours).
 */
data class DataExport(
    val url: String,
    /** ISO-8601 instant the link stops working. */
    val expiresAt: String,
    val fileName: String,
    val sizeBytes: Long,
    val files: List<String>,
    /** Records per kind, e.g. "shifts" to 42. */
    val counts: Map<String, Int>
)

/** Exports hand out pay and contact data: the person must sign in again first (10 minutes). */
class RecentSignInRequiredException : Exception("Sign in again to export data.")

/** One personal export a day. */
class ExportLimitReachedException : Exception("You can download your data once a day.")

/** The absence note is free text: kept short, and never medical details (art. 22¹ KP). */
class AbsenceReasonTooLongException(val maxLength: Int) : Exception("The note is longer than $maxLength characters.")

/** The legal documents the app links to and the versions people accept (SH-50). */
object LegalDocuments {
    /** "Effective as of" date of eula.html / privacy.html; bump with every change of the terms. */
    const val TERMS_VERSION = "2026-10-09"

    /** The data processing agreement is the annex of the terms (eula.html): same version. */
    const val DPA_VERSION = TERMS_VERSION

    private const val SITE = "https://evoshift.app"

    /** The policy in [language]: "/privacy_pl", "/privacy_uk" (SH-119), English "/privacy" otherwise. */
    fun privacyUrl(language: String): String = "$SITE/privacy" + suffix(language)

    fun termsUrl(language: String): String = "$SITE/eula" + suffix(language)

    private fun suffix(language: String): String = if (language == "pl" || language == "uk") "_$language" else ""
}
